import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export function formatDuration(milliseconds: number, format: string): string {
  return dayjs.duration(milliseconds).format(format);
}

export function formatDate(seconds: number | undefined, format: string) {
  if (seconds === undefined || !format) return undefined;
  return dayjs.unix(seconds).format(format);
}

export function millisToSec(millis: number): number;
export function millisToSec(millis: number | undefined): number | undefined;
export function millisToSec(millis: any): any {
  if (millis === undefined) return undefined;
  return millis / 1000;
}

export function secToMillis(millis: number): number;
export function secToMillis(sec: number | undefined): number | undefined;
export function secToMillis(sec: any): any {
  if (sec === undefined) return undefined;
  return sec * 1000;
}
